import {bindNotificationsModule} from "~/modules/notifications/store";

const VueStoreProviders = {

  install(Vue) {

    bindNotificationsModule(Vue);

    Vue.mixin({
      computed: {
        $functionalities() {
          return this.$store.getters.functionalities
        },
        $customisation() {
          return this.$store.getters.customisation
        }
      }
    })
  }
};

export {VueStoreProviders} ;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-65290d42/vue-store-providers.tsx" });